"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Loader = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Loader = function Loader(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/_react.default.createElement(_core.CircularProgress, _extends({
    size: 80,
    thickness: 3
  }, props));
};

exports.Loader = Loader;
var _default = Loader;
exports.default = _default;